import { CSSProperties } from "react";

const RefreshIcon = ({ scale, color, style }: { scale?: number; color?: string; style?: CSSProperties }) => {
  let c = "#1062D0";
  if (color) c = color;
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `scale(${scale || 1})` }}
    >
      <path
        d="M4.97705 15.3219C5.67255 16.0174 6.49824 16.5691 7.40698 16.9456C8.31571 17.322 9.28969 17.5157 10.2733 17.5157C11.2569 17.5157 12.2309 17.322 13.1396 16.9456C14.0484 16.5691 14.8741 16.0174 15.5696 15.3219L16.2324 14.6609"
        stroke={c}
        strokeWidth="2.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.2614 4.44165C14.5659 3.74612 13.1591 2.61322 12.2503 2.23679C11.3416 1.86037 10.3676 1.66663 9.38399 1.66663C8.40038 1.66663 7.4264 1.86037 6.51766 2.23679C5.60893 2.61322 4.78324 3.16495 4.08774 3.86049L3.42676 4.52147"
        stroke={c}
        strokeWidth="2.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.6702 2.75232L18.3331 7.38666L13.6987 6.72381L17.6702 2.75232Z"
        fill={c}
        stroke={c}
        strokeWidth="2.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.32929 16.645L1.66644 12.0107L6.30078 12.6735L2.32929 16.645Z"
        fill={c}
        stroke={c}
        strokeWidth="2.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default RefreshIcon;
